import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@core/interface/core';
import { ParkingManagementConfigurationActions } from './parking-management-configuration.actions';
import { ParkingManagementConfigurationItem, ParkingManagementConfigurationListItem } from '@core/interface/parking-managment-configuration';

export interface ListItemState {
  data: ParkingManagementConfigurationItem[];
  isLoading: boolean;
  isDeleted: boolean;
  pagination: Pagination | null;
}

export type ParkingManagementConfigurationMasterState = Record<ParkingManagementConfigurationListItem, ListItemState>;
const ListItems = Object.fromEntries(
  Object.values(ParkingManagementConfigurationListItem).map((key) => [
    key,
    {
      data: [],
      isLoading: true,
      isDeleted: false,
      pagination: null,
    },
  ])
) as unknown as Record<ParkingManagementConfigurationListItem, ListItemState>;
export const initialState: ParkingManagementConfigurationMasterState = {
  ...ListItems
};

export const ParkingManagementConfigurationReducer = createReducer(
  initialState,
  on(ParkingManagementConfigurationActions.loadParkingManagementConfigurationList, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: true },
    };
  }),
  on(ParkingManagementConfigurationActions.loadParkingManagementConfigurationListSuccess, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        data: action.response.data,
        isLoading: false,
        pagination: action.response.pagination,
      },
    };
  }),
  on(ParkingManagementConfigurationActions.loadParkingManagementConfigurationListFailure, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: false },
    };
  }),
  on(ParkingManagementConfigurationActions.updateParkingManagementConfigurationSuccess, (state, action) => {
      const index = state[action.key].data.findIndex(
        (item) => item.id == action.response.data.id
      );
      let data = [...state[action.key].data];
      if (index == -1) data = [...state[action.key].data, action.response.data];
      else data[index] = action.response.data;
  
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          data: data,
        },
      };
    }),
);
